import JSBI from 'jsbi'

/**
 * Returns the price of 1 gas in WEI for the currently selected network using the chainlink fast gas price oracle
 */
export default function useGasPrice () {
  const resultStr = '10000000000'
  return typeof resultStr === 'string' ? JSBI.BigInt(resultStr) : undefined
}
